// extracted by mini-css-extract-plugin
export var button = "_dz-0";
export var donut = "_dz-1";
export var donutFill = "_dz-3";
export var donutTrack = "_dz-2";